import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'wpDashboardCount',
  standalone: true
})
export class WpDashboardCountPipe implements PipeTransform {

  transform(statusCard: any[], apiData: { [key: string]: number }): any[] {
    return statusCard?.map((item) => {
      if(apiData){
        return {
          ...item,
          count: apiData[item.selected]?.toString() || 0,
        };
      }
    });
  }

}
